import { render, staticRenderFns } from "./PurchasingSection.vue?vue&type=template&id=2f58e001&scoped=true&"
import script from "./PurchasingSection.vue?vue&type=script&lang=js&"
export * from "./PurchasingSection.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingSection.vue?vue&type=style&index=0&id=2f58e001&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58e001",
  null
  
)

export default component.exports